/* Busqueda por voz - SiempreCompra
   Agrega un boton de microfono dentro de la barra de busqueda del tema.
   Usa la Web Speech API del navegador (gratis, sin apps externas). */
(function () {
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) return;

  var ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<rect x="9" y="2" width="6" height="11" rx="3"></rect>' +
    '<path d="M5 11a7 7 0 0 0 14 0"></path>' +
    '<line x1="12" y1="18" x2="12" y2="22"></line>' +
    '<line x1="8.5" y1="22" x2="15.5" y2="22"></line>' +
    '</svg>';

  var CSS =
    '.sc-voice-btn{position:absolute;left:10px;top:50%;transform:translateY(-50%);width:32px;height:32px;' +
    'display:flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:50%;' +
    'background:transparent;color:currentColor;cursor:pointer;opacity:.6;z-index:3;transition:opacity .2s,color .2s}' +
    '.sc-voice-btn:hover{opacity:1}' +
    '.sc-voice-btn svg{width:18px;height:18px;pointer-events:none}' +
    '.sc-voice-field .search__input{padding-left:48px}' +
    '.sc-voice-btn.is-listening{opacity:1;color:#c4301c}' +
    '.sc-voice-btn.is-listening:after{content:"";position:absolute;left:0;top:0;right:0;bottom:0;' +
    'border-radius:50%;border:2px solid currentColor;animation:sc-voice-pulse 1.2s ease-out infinite}' +
    '@keyframes sc-voice-pulse{0%{transform:scale(.7);opacity:.9}100%{transform:scale(1.7);opacity:0}}' +
    '.sc-voice-hint{position:absolute;left:50%;transform:translateX(-50%);top:calc(100% + 8px);' +
    'background:#111;color:#fff;font-size:12px;line-height:1.2;padding:8px 14px;border-radius:999px;' +
    'white-space:nowrap;z-index:20;pointer-events:none}';

  function injectCss() {
    if (document.getElementById('sc-voice-css')) return;
    var s = document.createElement('style');
    s.id = 'sc-voice-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function showHint(field, msg, ms) {
    var old = field.querySelector('.sc-voice-hint');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'sc-voice-hint';
    el.textContent = msg;
    field.appendChild(el);
    if (ms) {
      setTimeout(function () {
        if (el.parentNode) el.remove();
      }, ms);
    }
    return el;
  }

  function clearHint(field) {
    var el = field.querySelector('.sc-voice-hint');
    if (el) el.remove();
  }

  function attach(input) {
    if (!input || input.dataset.scVoice === '1') return;
    var field = input.closest('.search__field') || input.parentElement;
    if (!field) return;
    if (field.querySelector('.sc-voice-btn')) {
      input.dataset.scVoice = '1';
      return;
    }
    input.dataset.scVoice = '1';
    field.classList.add('sc-voice-field');
    if (window.getComputedStyle(field).position === 'static') {
      field.style.position = 'relative';
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sc-voice-btn';
    btn.title = 'Buscar por voz';
    btn.setAttribute('aria-label', 'Buscar por voz');
    btn.innerHTML = ICON;
    field.insertBefore(btn, field.firstChild);

    var rec = null;
    var listening = false;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (listening && rec) {
        rec.stop();
        return;
      }
      try {
        rec = new SR();
      } catch (err) {
        return;
      }
      var lang = document.documentElement.lang || '';
      rec.lang = lang.indexOf('es') === 0 ? 'es-CL' : lang || 'es-CL';
      rec.interimResults = true;
      rec.continuous = false;
      rec.maxAlternatives = 1;

      rec.onstart = function () {
        listening = true;
        btn.classList.add('is-listening');
        showHint(field, 'Te escucho... di lo que buscas');
        try {
          input.focus();
        } catch (err) {}
      };

      rec.onresult = function (ev) {
        var text = '';
        for (var i = 0; i < ev.results.length; i++) {
          text += ev.results[i][0].transcript;
        }
        text = text.replace(/\s+/g, ' ').trim();
        if (!text) return;
        input.value = text;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        var last = ev.results[ev.results.length - 1];
        if (last && last.isFinal) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      rec.onerror = function (ev) {
        listening = false;
        btn.classList.remove('is-listening');
        var msg = 'No te escuche bien, intenta de nuevo';
        if (ev && (ev.error === 'not-allowed' || ev.error === 'service-not-allowed')) {
          msg = 'Permite el microfono en tu navegador para buscar por voz';
        } else if (ev && ev.error === 'no-speech') {
          msg = 'No escuche nada, intenta de nuevo';
        }
        showHint(field, msg, 3500);
      };

      rec.onend = function () {
        listening = false;
        btn.classList.remove('is-listening');
        var hint = field.querySelector('.sc-voice-hint');
        if (hint && hint.textContent.indexOf('Te escucho') === 0) clearHint(field);
      };

      try {
        rec.start();
      } catch (err) {}
    });
  }

  function scan() {
    var inputs = document.querySelectorAll('input.search__input, .search__field input[name="q"]');
    for (var i = 0; i < inputs.length; i++) attach(inputs[i]);
  }

  function init() {
    injectCss();
    scan();
    if (window.MutationObserver) {
      var obs = new MutationObserver(function () {
        scan();
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
